module.exports = __webpack_public_path__ + "static/media/kisan_mar.8b0107eb.png";